import axios from 'axios';
import CryptoJS from 'crypto-js';
import { navigate } from 'hookrouter';
import { confirmAlert } from 'react-confirm-alert'; 
import 'react-confirm-alert/src/react-confirm-alert.css'

    const DoLogin = (formItems) => {
        axios(PostOptions(formItems, 'profile/validate'))
        .then(res => {
            let user = DecryptData(res.data);

            setUser(user);
            window.location.reload();
        }).catch(error => alert(`Error: ${error.message}`));
    }

    const Logout = () => {
        sessionStorage.removeItem('getp_crg_token');
        sessionStorage.removeItem('getp_crg_user');
        sessionStorage.removeItem('getp_crg_features');
        sessionStorage.removeItem('registration');
        sessionStorage.removeItem('area');
        navigate('/',true);
    }

    const EncryptData = (data) => {
        let keyHex = CryptoJS.enc.Base64.parse(PrivateKey());
        let encrypted = CryptoJS.AES.encrypt(data, keyHex, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });

        return encrypted.toString();
    }

    const DecryptData = (data) => {
        let keyHex = CryptoJS.enc.Base64.parse(PrivateKey());
        let decrypted = CryptoJS.AES.decrypt({
            ciphertext: CryptoJS.enc.Base64.parse(data)
        }, keyHex, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });

        return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
    }

    const DecryptCAPBUSS = (data) => {
        let keyHex = CryptoJS.enc.Base64.parse('N9Bt8inyra0=');
        let decrypted = CryptoJS.DES.decrypt({
            ciphertext: CryptoJS.enc.Base64.parse(data)
        }, keyHex, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });

        return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
    }

    const EncryptCAPBUSS = (data) => {
        let keyHex = CryptoJS.enc.Base64.parse('N9Bt8inyra0=');
        let encrypted = CryptoJS.DES.encrypt(data, keyHex, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });

        return encrypted.toString();
    }

    const DecryptText = (data) => {
        let keyHex = CryptoJS.enc.Base64.parse(PrivateKey())
        let decrypted = CryptoJS.DES.decrypt({
            ciphertext: CryptoJS.enc.Base64.parse(data)
        }, keyHex, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });

        return decrypted.toString(CryptoJS.enc.Utf8);
    }

    const MapFields = ({data, fields}) => {
        alert(JSON.stringify(data))
        let result = {};

        Object.keys(fields).map(key => {
            result[key] = data[fields[key]]
        });

        return result;
    }

    const PrivateKey = () => 'XSbXJQqF4+CfX7YleAW6gPkXgSKCy8SMqvWRueQOw2k=';
    const LoggedIn = () => getUser() !== null;

    const setUser = (user) => sessionStorage.setItem('getp_crg_user', JSON.stringify(user));
    const getUser = () => JSON.parse(sessionStorage.getItem('getp_crg_user'));

    const setToken = (token) => sessionStorage.setItem('getp_crg_token', token);
    const getToken = () => sessionStorage.getItem('getp_crg_token');

    const getAuthorization = () => (getUser() == null) ? 
        {'username':'', 'token':''} : 
        {'username':getUser().username, 'token':getUser().token};

    const setFeatures = (userole) => sessionStorage.setItem('features', JSON.stringify(userole));
    const getFeatures = () => JSON.parse(sessionStorage.getItem('features'));

    const setCookie = (name, value) => sessionStorage.setItem(name, value);
    const getCookie = (name) => sessionStorage.getItem(name);

    const IsAuthenticated = () => LoggedIn();

    const GetCapBuss = () => {
        return axios.create({
            baseURL: 'https://backend.nbssighcap.com/api/',
            timeout: 60000,
            headers: {
            'Content-Type': 'application/json'/*,
            'Authorization': JSON.stringify(auth.getAuthorization())*/
            }
        });
    }

    const PostCAPBUSS = (itms, area) => {
        var formBody = [];
        for (var property in itms) {
            var encodedKey = encodeURIComponent(property);
            var encodedValue = encodeURIComponent(itms[property]);
            formBody.push(encodedKey + "=" + encodedValue); 
        }

        formBody = formBody.join("&");

        return {
            method: 'post',
            url: 'https://backend.nbssighcap.com/api/' + area,
            data: formBody,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
        }
    }

    const DConnect = () => {
        return axios.create({
            baseURL: BaseURL() + 'v1.0/',
            timeout: 60000,
            headers: {
            'Content-Type': 'application/json',
            'Cache-Control': 'no-store'/*,
            'Authorization': JSON.stringify(auth.getAuthorization())*/
            }
        });
    }

    const PostOptions = (meth, formBody, area) => {
        let formData = `data=${encodeURIComponent(EncryptData(JSON.stringify(formBody)))}`;
        
        return {
            method: meth,
            url: BaseURL() + 'v1.0/' + area,
            data: formData,
            headers: {
                'Accept': 'application/json',
                'Cache-Control': 'no-store',
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'/*,
                'Authorization': JSON.stringify(auth.getAuthorization())*/
            }
        }
    }

    const TinVerification = (tin_number) => {
        let base = tin_number.substr(1);
        let result = false;

        if(base.length == 10){
            result = verifyTIN(base);

            if(!result){
                let unbase = base.slice(0, -1);
                
                for(var i=1; i<=unbase.length; i++){
                    result = verifyTIN(unbase+i);

                    if(!result){ continue; }
                    break;
                }
            }
        }

        return result;
    } 

    const verifyTIN = (code) => {
        var str = code.toString();
        var strLen = str.length,
            strVal = parseInt(str);
        if (strLen < 8 || strLen > 10 || isNaN(strVal) || strVal == 0)
            return false;
        while (str.length < 10) str = '0' + str;
        if (str.match(/^(\d)\1+$/g)) return false;
        var checkDigit = parseInt(str.slice(-1)),
            str = str.slice(0, -1);
        for (var sum = 0, i = str.length; i > 0; i--)
            sum += (i + 1) * str.substr(-i, 1);
        var mod = sum % 11;
        return (mod < 2 && mod === checkDigit) || (mod >= 2 && mod + checkDigit === 11);
    } 

    const MakeId = (length) => {
        var result = '';
        var characters = '0123456789';
        var charactersLength = characters.length;

        for (var i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return 'HGP' + result;
    }

    const Alert = (props) => (
        confirmAlert({ title: props.title, message: props.message, buttons: props.buttons })
    );

    const BaseURL = () => {
        //return 'http://localhost:9040/';
        //return 'http://test.gheaonline.com:9060/';
        return 'https://shgp.gheaonline.com/';
    }

    const Config = () => {

    }

    Config.DoLogin = DoLogin;
    Config.Logout = Logout;
    Config.EncryptData = EncryptData;
    Config.DecryptData = DecryptData;
    Config.DecryptCAPBUSS = DecryptCAPBUSS;
    Config.EncryptCAPBUSS = EncryptCAPBUSS;
    Config.GetCapBuss = GetCapBuss;
    Config.DecryptText = DecryptText;
    Config.PrivateKey = PrivateKey;
    Config.LoggedIn = LoggedIn;
    Config.setUser = setUser;
    Config.getUser = getUser;
    Config.setToken = setToken;
    Config.getToken = getToken;
    Config.setFeatures = setFeatures;
    Config.getFeatures = getFeatures;
    Config.IsAuthenticated = IsAuthenticated
    Config.getAuthorization = getAuthorization;
    Config.setCookie = setCookie;
    Config.getCookie = getCookie;

    Config.DConnect = DConnect;
    Config.PostOptions = PostOptions;
    Config.PostCAPBUSS = PostCAPBUSS;
    Config.BaseURL = BaseURL;
    Config.MapFields = MapFields;
    Config.TinVerification = TinVerification
    Config.MakeId = MakeId;
    Config.Alert = Alert;

    export default Config;
    export {
        DoLogin, Logout, EncryptData, DecryptData, DecryptText, DecryptCAPBUSS, MakeId,
        PrivateKey, LoggedIn, setUser, getUser, setToken, getToken, GetCapBuss, PostCAPBUSS,
        getAuthorization, setFeatures, getFeatures, DConnect, MapFields, EncryptCAPBUSS,
        PostOptions, BaseURL, IsAuthenticated, setCookie, getCookie, TinVerification,
        Alert
    }